import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import { Fab, Fade, Grid, LinearProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import UploadAction from './UploadAction';

const useStyles = makeStyles()((theme) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bannerControls: {
    zIndex: 1,
    position: 'absolute',
  },
  banner: {
    height: 560,
    display: 'block',

    width: '100%',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.down('lg')]: {
      height: 200,
    },
  },
}));

type BannerFormProps = {
  bannerUrl: string | null;
  type: 'showroom' | 'storefront';
  loading?: boolean;
  onChange: (file?: File) => void;
};

const BannerForm = ({ bannerUrl, loading, type, onChange }: BannerFormProps) => {
  const { classes, cx } = useStyles();

  const handleFileChange = (files: FileList | null) => {
    if (files) {
      onChange(files[0]);
    }
  };

  return (
    <>
      <div className={classes.container}>
        <div className={cx(classes.bannerControls)}>
          <Grid container spacing={2}>
            {bannerUrl && (
              <Grid>
                <Fab aria-label="remove" onClick={() => onChange(undefined)} disabled={loading}>
                  <DeleteOutlineIcon />
                </Fab>
              </Grid>
            )}
            <Grid>
              <UploadAction proccessFiles={handleFileChange} disabled={loading}>
                <Fab color="primary" aria-label="add" disabled={loading}>
                  <PhotoCameraOutlinedIcon />
                </Fab>
              </UploadAction>
            </Grid>
          </Grid>
        </div>

        <img
          alt="banner"
          className={classes.banner}
          style={{ objectFit: bannerUrl ? 'cover' : 'inherit' }}
          src={
            bannerUrl ||
            (type === 'showroom' ? '/images/showroom-banner.svg' : '/images/storefront-banner.svg')
          }
        />
      </div>
      <Fade in={loading}>
        <LinearProgress />
      </Fade>
    </>
  );
};

export default BannerForm;
